import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useGetSearchParam = (param: string): string | null => {
  const [searchParams] = useSearchParams();

  return useMemo(() => searchParams.get(param), [searchParams]);
};
